export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. Usamos Whop y PayPal, sistemas de pago certificados internacionalmente. Tu información está 100% protegida.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Pago único sin suscripción. Acceso de por vida al material.'
  },
  {
    q: '¿Sirve para entrenadores con poca experiencia?',
    a: 'Totalmente. El Bono #1 "Plan de Arranque 7 Días" está diseñado exactamente para eso: te guía paso a paso sin necesidad de revisar todo el material desde el principio.'
  },
  {
    q: '¿Puedo usarlo solo para una categoría concreta?',
    a: 'Sí. Los tomos incluyen tres niveles de entrada (iniciación, continuidad y juego organizado) para que elijas el nivel que corresponde a tu equipo, no una versión distinta por cada edad.'
  },
  {
    q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
    a: 'El Tomo 2 incluye variantes de cada ejercicio (fácil, medio, difícil) para que puedas adaptar en tiempo real. Todos progresan sin aburrir a los avanzados.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'PDF descargable, imprimible y optimizado para móvil. Funciona en cualquier dispositivo.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Sí. Garantía de 7 días: si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  },
  {
    q: '¿Puedo comprar VOLEY-PRO 360 desde cualquier país?',
    a: 'Sí. VOLEY-PRO 360 es un producto digital en español, pensado para entrenadores de voleibol de diferentes países. Puedes utilizar sus ejercicios y sesiones adaptándolos al nivel de tus jugadores, la organización de tu equipo y el calendario de competición. El acceso se entrega digitalmente y la compra está sujeta a los métodos de pago disponibles en tu país.'
  }
];
